import React from 'react';
import { Grid } from '../grid';
import { ListItem } from './components/listItem';
export type { ListItem } from './components/listItem';

export const List: React.FC<{ items: string[]; columnCount: number }> = ({ items, columnCount }) => {
  const columnsWithItems: string[][] = [];
  const itemsCountInColumn = items.length / columnCount;

  for (let i = 0; i < items.length; i += itemsCountInColumn) {
    const column = items.slice(i, i + itemsCountInColumn);

    if (column.length) {
      columnsWithItems.push(column);
    }
  }

  return (
    <Grid columnSpacing={1.5} container>
      {columnsWithItems.map((column, index) => (
        <Grid item key={index} xs={12 / columnCount}>
          {column.map((item, i) => (
            <ListItem key={i} label={item} />
          ))}
        </Grid>
      ))}
    </Grid>
  );
};
